module.exports = __webpack_public_path__ + "img/315.9a295458.png";